import React from 'react';

import SesamTextField from '../common/SesamTextField/SesamTextField';
import { ConnectPanelActions } from './ConnectPanelActions.view';
import { LinkButton } from '../common/LinkButton/LinkButton';
import { Form } from '../common/forms';
import Feedback from '../feedback';

import { colors } from '../../colors';

import { TestID } from '../../testID';

import type { SubscriptionService } from 'src/types/subscription.types';

export const ConnectPanel: React.FC<{
  canConnect: boolean;
  canSetDefault: boolean;
  connect: (event: React.FormEvent<HTMLFormElement>) => void;
  couldNotConnect: boolean;
  disableCheckbox: boolean;
  handleFieldChange: (event: React.InputEvent<HTMLInputElement>) => void;
  handleOpenFailedModal: (event: React.MouseEvent<HTMLButtonElement>) => void;
  notValid: boolean;
  persistedURL?: string;
  persistedURLCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
  pleaseWait: boolean;
  serviceType: SubscriptionService;
  shouldPersistURL: boolean;
  stored: string;
  setUrlAsDefault: (event: React.MouseEvent<HTMLButtonElement>) => void;
  storing: boolean;
  url: string;
}> = ({
  canConnect,
  canSetDefault,
  connect,
  couldNotConnect,
  disableCheckbox,
  handleFieldChange,
  handleOpenFailedModal,
  notValid,
  persistedURL,
  persistedURLCheckbox,
  pleaseWait,
  serviceType,
  shouldPersistURL,
  stored,
  setUrlAsDefault,
  storing,
  url,
}) => (
  <Form onSubmit={connect} standout>
    <SesamTextField
      margin="normal"
      id="url"
      onChange={handleFieldChange}
      disabled={pleaseWait}
      type="url"
      value={persistedURL || url}
      label="Override default URL"
      helperText={
        notValid ? (
          <span style={{ color: colors.dark.danger }}>URL is required</span>
        ) : (
          <span>
            Full URL, starting with <code>https://</code> and ending in <code>/api</code>
          </span>
        )
      }
      inputTestid={TestID.CustomConnectionStringInput}
    />
    <ConnectPanelActions
      canConnect={canConnect}
      canSetDefault={canSetDefault}
      disableCheckbox={disableCheckbox}
      persistedURLCheckbox={persistedURLCheckbox}
      serviceType={serviceType}
      shouldPersistURL={shouldPersistURL}
      storing={storing}
      setUrlAsDefault={setUrlAsDefault}
      pleaseWait={pleaseWait}
      url={url}
    />
    {stored && <Feedback>Will connect via {stored} from now on.</Feedback>}
    {couldNotConnect && (
      <Feedback type="error" data-testid={TestID.ConnectionFailedMessage}>
        Connection failed.{' '}
        <LinkButton
          onClick={handleOpenFailedModal}
          data-testid={TestID.ConnectionFailedMessageDetailsLinkButton}
        >
          Details
        </LinkButton>
      </Feedback>
    )}
  </Form>
);
